import BlurText from "@core-components/BlurText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import CopyText from "@modules/clientDashboard/components/CopyText";
import { IconEye, IconEyeOff } from "@tabler/icons-react";

interface ICopyPasswordProps {
  password: string;
  isBlurred?: boolean;
  className?: string;
}

const CopyPassword: React.FC<ICopyPasswordProps> = ({
  password = "John's password",
  isBlurred,
  className,
}) => {
  const { t } = useAppTranslation("pages.order.tracking.credentials");
  const [showPassword, { toggle }] = useDisclosure(false);

  return (
    <BlurText isBlurred={isBlurred}>
      <Group
        wrap="nowrap"
        gap={5}
        className={`hover-scale text-primary-white ${className}`}
        align="center"
      >
        <CopyText
          value={password}
          variant="transparent"
          className="!text-primary-white p-0"
          classNames={{ label: "!text-base font-normal" }}
          notificationLabel={t("copyPassword")}
        >
          {showPassword ? password : "*******"}
        </CopyText>
        {showPassword ? (
          <IconEye onClick={toggle} size={15} className="cursor-pointer" />
        ) : (
          <IconEyeOff onClick={toggle} size={15} className="cursor-pointer" />
        )}
      </Group>
    </BlurText>
  );
};

export default CopyPassword;
